import {
  ArrowRight,
  Sparkles,
  Gem,
} from "lucide-react";
import {
  COLOR_CHARCOAL,
  COLOR_MUTED,
} from "../constants/upsellPage.constants";
import AmbientGradient from "./primitives/AmbientGradient";
import Pill from "./primitives/Pill";
import type { ContactSectionProps } from "../types/upsellPage.types";

const ContactSection = ({
  targetPlanName,
  targetTier = "standard",
  pageFeatureTitle,
  premiumFeaturesCount,
  onSubscribe,
}: ContactSectionProps) => {
  const isPremium = targetTier === "premium";
  const BadgeIcon = isPremium ? Gem : Sparkles;
  const planCode: "standard" | "premium" = isPremium ? "premium" : "standard";

  return (
    <section className="relative isolate px-4 pt-24 pb-32 sm:pt-32 sm:pb-48">
      <AmbientGradient position="closing" />

      <div className="relative z-10 mx-auto flex max-w-3xl flex-col items-center text-center">
        <Pill
          variant="tinted-purple"
          size="sm"
          icon={<BadgeIcon size={14} strokeWidth={2} />}
          className="animate-upsell-fade-in mb-6"
        >
          {targetPlanName}
        </Pill>

        <h2
          className="animate-upsell-fade-in-up mb-5 font-light tracking-tight"
          style={{
            color: COLOR_CHARCOAL,
            fontSize: "clamp(2rem, 4.5vw, 3.25rem)",
            lineHeight: 1.1,
            letterSpacing: "-0.02em",
            animationDelay: "0.05s",
          }}
        >
          Prêt à passer au
          {" "}
          <span style={{ fontWeight: 500 }}>{targetPlanName}</span>
          {" "}
          ?
        </h2>

        <p
          className="animate-upsell-fade-in-up mb-10 max-w-xl text-base sm:text-lg"
          style={{
            color: COLOR_MUTED,
            lineHeight: 1.55,
            animationDelay: "0.1s",
          }}
        >
          Débloquez
          {" "}
          <span style={{ color: COLOR_CHARCOAL, fontWeight: 500 }}>{pageFeatureTitle}</span>
          {" "}
          et
          {" "}
          <span style={{ color: COLOR_CHARCOAL, fontWeight: 500 }}>
            {premiumFeaturesCount}
            {" "}
            fonctionnalité
            {premiumFeaturesCount > 1 ? "s" : ""}
          </span>
          {" "}
          pour accompagner votre CSE.
        </p>

        {onSubscribe && (
          <div
            className="animate-upsell-fade-in-up"
            style={{ animationDelay: "0.2s" }}
          >
            <Pill
              as="button"
              variant="purple"
              size="lg"
              type="button"
              onClick={() => onSubscribe(planCode)}
            >
              Souscrire au
              {" "}
              {targetPlanName}
              <ArrowRight size={16} strokeWidth={2} />
            </Pill>
          </div>
        )}
      </div>
    </section>
  );
};

export default ContactSection;
